module.exports = __webpack_public_path__ + "img/icon-tool.88114032.svg";